export default __webpack_public_path__ + "static/media/PhonePe.430cc9d7.svg";